import { Modal, ModalContent, ModalHeader, ModalBody, ModalFooter, Button } from '@heroui/react';
import type { ReactNode } from 'react';

interface ConfirmDialogProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  title: string;
  body: ReactNode;
  confirmLabel?: string;
  cancelLabel?: string;
  tone?: 'danger' | 'warning' | 'primary';
  isLoading?: boolean;
}

/** Reusable confirmation modal for destructive/irreversible actions. */
export function ConfirmDialog({
  isOpen, onClose, onConfirm, title, body,
  confirmLabel = 'Confirm', cancelLabel = 'Cancel', tone = 'danger', isLoading = false,
}: ConfirmDialogProps) {
  return (
    <Modal isOpen={isOpen} onClose={onClose} size="md" backdrop="blur">
      <ModalContent>
        <ModalHeader className="text-fg">{title}</ModalHeader>
        <ModalBody className="text-sm text-fg-muted">{body}</ModalBody>
        <ModalFooter>
          <Button variant="light" onPress={onClose} isDisabled={isLoading}>{cancelLabel}</Button>
          <Button color={tone} onPress={onConfirm} isLoading={isLoading}>{confirmLabel}</Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
}
